import { EvidenceType } from './platformEvidenceTypes';

export type TBadUtterance = {
  abuseType: string;
  labelTranslationKey: string;
  utteranceText: string;
};

export type TVerificationCategory = '' | 'Email' | 'VPC';

export interface TDisplayMeta {
  lowercaseKey: string;
  capitalizedKey: string;
  icon: string;
}

export interface TEvidence {
  type: EvidenceType;
  elements?: any[];
  elementsObj?: Record<string, any>;
  displayMeta?: TDisplayMeta;
}

export interface TViolation {
  uid: string;
  abuseTypeTranslationKeys: string[];
  evidence: TEvidence;
  // TODO(agrossman): support content (legacy) violations too
}

export type TPunishment = {
  agreedCheckBoxExperimentVariant?: string;
  badUtterances: TBadUtterance[];
  beginDate: string;
  consequenceTransparencyMessage: string;
  context: Record<string, unknown>;
  endDate: string;
  isForeshadowingConsequenceEnabled?: boolean;
  interventionId: string;
  messageToUser: string;
  punishedUserId: number;
  punishmentId: number;
  punishmentTypeDescription: string;
  showAppealsProcessLink: boolean;
  verificationCategory: TVerificationCategory;
  violation?: TViolation;
};

export enum ProceedAction {
  Reactivate,
  VerifyEmail,
  VerifyVPC
}

export enum AMPRecoursePunishmentType {
  Chargeback = 'Chargeback'
}
